import { FronteggContext } from '@frontegg/rest-api';
import { AxiosAmbient } from 'src/lib';
import { showToastError } from 'src/utilities/errortoast';
import { showToastSuccess } from 'src/utilities/toast';

import {
  createdAutoTemplateSlice,
  autoTemplateDraftUuidSlice,
} from '../slices/autotemplate.slice';

export const createAutoTemplate = async (data, dispatch) => {
  const { files, content, ...rest } = data;

  try {
    const formData = new FormData();
    formData.append('source', 'auto_template');

    // Add content if provided
    if (content) {
      formData.append('content', content);
    }

    // Add all other properties
    Object.entries(rest).forEach(([key, value]) => {
      formData.append(key, value);
    });

    // Add multiple files
    if (files && files.length > 0) {
      files.forEach((file) => {
        formData.append('files', file);
      });
    }

    const headers = {
      'Content-Type': 'multipart/form-data',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };

    const result = await AxiosAmbient.post('/auto_template', formData, {
      headers,
    });
    const response = result.data;
    if (result?.status < 300) {
      dispatch(autoTemplateDraftUuidSlice(response?.auto_template_result_uuid));
      return response;
    }
  } catch (error) {
    showToastError('Failed to upload documents');
    throw error;
  }
};

export const getAutoTemplateDraft = (uuid, dispatch) => async () => {
  const token = FronteggContext.getAccessToken();
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
  };
  const result = await AxiosAmbient.get(`/auto_template/draft/${uuid}`, {
    headers,
  });
  const response = result.data;
  if (result?.status < 300) {
    dispatch(createdAutoTemplateSlice(response));
    return response;
  }
  return null;
};

export const createAutoTemplateSuccess = (
  payload,
  successCallback,
  failureCallback
) => {
  return async (dispatch) => {
    try {
      const body = {
        template_name: payload?.template_name,
        template_type: payload?.template_type,
        auto_template_result_uuid: payload?.auto_template_result_uuid,
      };
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      };
      const result = await AxiosAmbient.post('/auto_template/create', body, {
        headers,
      });
      const response = result?.data;
      if (result?.status === 200) {
        showToastSuccess('Auto template created successfully');
        dispatch(autoTemplateDraftUuidSlice(null));
        successCallback(response?.template_overrides_id);
      }
    } catch (e) {
      showToastError('Failed to create auto template');
      failureCallback();
    }
  };
};
